/* eslint-disable max-len */
import React, { SVGAttributes } from 'react';

export default ({ color = '#FFF', ...props }: SVGAttributes<SVGElement> & { color?: string }) => (
	<svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" {...props}>
		<rect x="5.5" y="7" width="3" height="10" rx="1" ry="1" fill={color} />
		<rect x="10.5" y="7" width="3" height="10" rx="1" ry="1" fill={color} />
		<rect x="15.5" y="7" width="3" height="10" rx="1" ry="1" fill={color} />
	</svg>
);
